import { useFormContext } from 'react-hook-form';

import { RHFTextInput } from 'components/input/RHFTextInput';

import { QuickQuoteInputs, QuickQuoteTextInputProps } from '../types';

export const QuickQuoteTextInput = (props: QuickQuoteTextInputProps) => {
  const {
    formState: { errors },
  } = useFormContext<QuickQuoteInputs>();

  const fieldName = props.name;

  const getStopLocationError = (fieldName: string) => {
    const match = fieldName.match(/^stops\.(\d+)\.location$/);
    if (match) {
      const stopIndex = parseInt(match[1], 10);
      return errors.stops?.[stopIndex]?.location;
    }
    return false;
  };

  const stopLocationError = getStopLocationError(fieldName);

  const inputClassName = stopLocationError
    ? `${props.inputClassName || ''} bg-error-50 border-error-500`
    : props.inputClassName;

  return <RHFTextInput {...props} inputClassName={inputClassName} />;
};
